import { connect } from 'react-redux';

import { ILoginState } from '@share/store/slices';
import { RootState } from '@share/utils';

import { ModernHero } from '../modern-hero';
import { ModernGetawayCarousel } from '../modern-getaway-carousel';
import { ModernPromotionalBanners } from '../modern-promotional-banners';
import { ModernQuickAccess } from '../modern-quick-access';
import { ModernFooter } from '../modern-footer';

import './style.scss';

interface IMapStateToProps {
  loginStore: ILoginState;
}

interface IProps extends IMapStateToProps {}

function HomeModernComponent(props: IProps) {
  const { loginStore } = props;
  const { account } = loginStore;

  const accountName = account?.name || '';

  return (
    <div className="home-modern">
      <div className="home-modern__container">
        <main className="home-modern__main">
          <ModernHero accountName={accountName} />
          <ModernGetawayCarousel accountName={accountName} />
          <ModernPromotionalBanners accountName={accountName} />
          <ModernQuickAccess accountName={accountName} />
          <ModernFooter accountName={accountName} />
        </main>
      </div>
    </div>
  );
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    loginStore: state.loginStore,
  };
};

export const HomeModern = connect(mapStateToProps)(HomeModernComponent);
